import { render, staticRenderFns } from "./IndustrialServiceIndustryLightIndustrial.vue?vue&type=template&id=5d6e540e&scoped=true&"
import script from "./IndustrialServiceIndustryLightIndustrial.vue?vue&type=script&lang=ts&"
export * from "./IndustrialServiceIndustryLightIndustrial.vue?vue&type=script&lang=ts&"
import style0 from "./IndustrialServiceIndustryLightIndustrial.vue?vue&type=style&index=0&id=5d6e540e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e540e",
  null
  
)

export default component.exports